export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Кепка снепбек с прямым козырьком</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `
        <ul>
          <li>Термоперенос</li>
          <li>Вышивка</li>
        </ul>
      `
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
